package horcrux.frontend.common.views.navigation

import horcrux.frontend.common.LazyValFromEffect
import horcrux.frontend.common.configs.StaticContentConfigs
import horcrux.frontend.common.views.components.containers.VStack
import js.objects.jso
import mui.icons.material.KeyboardArrowDown
import mui.icons.material.KeyboardArrowUp
import mui.material.Fab
import mui.material.FabVariant
import mui.material.Size
import mui.system.sx
import react.FC
import react.Props
import react.dom.aria.ariaLabel
import web.cssom.Position
import web.cssom.pct
import web.cssom.pt
import web.dom.document
import web.scroll.ScrollBehavior
import web.window.window

external interface ScrollToEndButtonsProps : Props

val ScrollToEndButtons = FC<ScrollToEndButtonsProps> { props ->
    var scrollHeightLazyVal = LazyValFromEffect { document.body.scrollHeight.toDouble() }
    VStack {
        this.sx {
            this.position = Position.fixed
            this.bottom = 50.pct
            this.right = 16.pt
        }
        listOf(
            Triple(KeyboardArrowUp, "Scroll To Top") { 0.0 },
            Triple(KeyboardArrowDown, "Scroll To Bottom") { scrollHeightLazyVal.valueMaybe }
        ).forEach {
            val icon = it.first
            val ariaLabel = it.second
            val topSupplier = it.third
            Fab {
                icon {}
                this.sx {
                    this.color = StaticContentConfigs.WHITE
                    this.backgroundColor = StaticContentConfigs.BLUE
                }
                this.size = Size.small
                this.ariaLabel = ariaLabel
                this.variant = FabVariant.circular
                this.onClick = {
                    window.scrollTo(jso {
                        this.top = topSupplier()
                        this.behavior = ScrollBehavior.smooth
                    })
                }
            }
        }
    }
}
